/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { Asset } from '../asset/asset'
 * @import { MediumAttrs } from './medium-attrs'
 * @import { Stringable } from '../stringable'
 */

/**
 * Transient model pro médium.
 * @typedef {MediumAttrs & Stringable} Medium
 */

/**
 * @typedef {string} URI
 */

/**
 * Vrátí uri daného media. Pokud uri není dostupné
 * (stará verze Ki-Wi Server nebo Webové/Kioskové medium),
 * tak vrátí zpětně kompatibilně URL.
 * @param {Medium} medium
 * @returns {string}
 */
export function getUri(medium) {
  return medium.uri ?? medium.url;
}

// TODO: Nyní triviální funkce, takže skoro ke zrušení. Na druhou stranu,
// alespoň jde snadno najít místa modifikací.
/**
 * Nalinkuje asset (perzistentně uložená entita z JSData) do Medium (transient doménový objekt).
 * @param {Pick<Medium, 'asset'>} medium
 * @param {Asset | undefined} asset
 */
export function linkAsset(medium, asset) {
  medium.asset = asset;
}

/**
 * Zjistí, zda má medium přiřazený asset.
 * @param {Medium} medium
 * @returns {medium is Medium & { asset: NonNullable<Asset> }}
 */
export function hasAsset(medium) {
  return medium.asset !== undefined;
}
